// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import qs from 'qs'
import VueWechatTitle from 'vue-wechat-title';
import weui from 'weui.js'
import 'weui'
import vueAwesomeSwiper from 'vue-awesome-swiper'
// import Swiper from 'swiper'
// import 'swiper/swiper-bundle.min.css'
import "swiper/dist/css/swiper.css"
import animated from 'animate.css' // npm install animate.css --save安装，在引入
import $ from 'jQuery'

import apis from '@/request/apis'

Vue.use(animated)
Vue.use(VueWechatTitle)
Vue.use(vueAwesomeSwiper)
// Vue.use(Swiper)

Vue.prototype.$apis = apis
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$qs = qs
Vue.prototype.$weui = weui
Vue.prototype.$ = $

import '../static/css/reset.css'
import '../static/js/flexible.js'
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js